<!-- day-calendar.html -->
<div class="day-calendar">
  <!-- Data atual -->
  <div class="date-display">
    <h2 class="current-date">
      {{ dayNumber }} de {{ monthName | titlecase }}
    </h2>
  </div>

  <!-- Estados de loading/error -->
  <div class="loading-state" *ngIf="loading">
    <div class="spinner"></div>
    <p>Carregando agendamentos...</p>
  </div>

  <div class="error-state" *ngIf="error && !loading">
    <div class="error-icon">⚠️</div>
    <p>Erro ao carregar agendamentos</p>
    <button class="retry-button" (click)="loadAppointmentsForDay()">Tentar novamente</button>
  </div>

  <!-- Lista de horários -->
  <div class="time-slots-container" *ngIf="!loading && !error">
    <div class="time-slots-list">

      <!-- Para cada horário (8:00, 9:00, etc.) -->
      <div class="time-slot-row" *ngFor="let slot of timeSlots; let last = last">

        <!-- Linha do horário -->
        <div class="time-slot-line">

          <!-- Horário à esquerda -->
          <div class="time-label">
            <span class="time-hour">{{ slot.hour }}</span>
          </div>

          <!-- Agendamentos -->
          <div class="appointments-side">

            <!-- Para cada agendamento -->
            <div class="appointment-item"
                 *ngFor="let appointment of slot.appointments">

              <!-- Retângulo do agendamento - ADICIONADO (click) -->
              <div class="appointment-rectangle"
                   (click)="navigateToLeadDetails(appointment.idLead)"
                   style="cursor: pointer;">

                <!-- Conteúdo do retângulo -->
                <div class="appointment-content">

                  <!-- Nome e horário na mesma linha -->
                  <div class="client-info">
                    <span class="client-name">{{ appointment.nomeCliente }}</span>
                    <span class="time-separator">,</span>
                    <span class="appointment-time">{{ appointment.horarioAgendamento }}</span>
                  </div>

                  <!-- Vendedor à direita -->
                  <div class="seller-info">
                    Agendado pelo vendedor: {{ appointment.nomeVendedor }}
                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>

        <!-- Divider horizontal (exceto na última linha) -->
        <div class="horizontal-divider" *ngIf="!last"></div>

      </div>

    </div>
  </div>
</div>
